import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Version from '@type/course/version'
import Cookies from 'js-cookie'

/**
 * Update course
 * @param courseId
 * @param updatedFields
 * @param version
 */
const updateCourse = (
  courseId: string,
  updatedFields: {},
  version: number
): Promise<Version> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL = routes.COURSE + courseId + '/' + version
    const data = {
      updatedFields: updatedFields,
    }
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }
    AxiosClient.patch(URL, data, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default updateCourse
